import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { BeforeStartComponent } from '../at-a-glance/before-start-application/before-start-application.component';
import {ApplicationService} from 'app/services/application/application.service';
import { StateService } from '@app/services/state/state.service';
import { toISO} from '@app/helpers/date.helpers';
import { StorageService } from '@app/services/storage/storage.service';
import { Title } from '@angular/platform-browser';
import { ModalService } from '@app/services/modal/modal.service';
import { HttpHeaders } from '@angular/common/http';
import { ApiService } from "@app/gateway/services/api.service";
import { GoogleAnalyticsService } from '@app/services/analytics/analytics.service';
import { TokenService } from '@app/services/token/token.service';
@Component({
    selector: 'welcome-back',
    templateUrl: './welcome-back.component.html',
    styleUrls: ['./welcome-back.component.scss'],
    standalone: false
})

export class WelcomeBackComponent implements OnInit {
  constructor(
    private beforeStart: BeforeStartComponent, 
    private router: Router, 
    private app: ApplicationService, 
    private stateService: StateService, 
    protected storageService: StorageService,
    private titleService: Title,
    private modal: ModalService,
    public apiService: ApiService,
    public analytics: GoogleAnalyticsService,
    private token: TokenService
  ) {
    this.titleService.setTitle('Welcome Back');
  }
  news = [];
  applicationNum;
  appType = '';
  setMessage;
  lastAccessed;
  user;
  headOfHouseholdName;
  isKepro;
  hohSSN;
  hohDob;
  hohGender;
  lastAccessedBy;
  appStartOn;
  appStartedBy;
  isEbmsUser = false;
  mobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;

  ngOnInit() {
    this.isEbmsUser = JSON.parse(sessionStorage.getItem("ebmsUser"))
    if(this.isEbmsUser) {
      this.analytics.trackEbmsWBNudgeShown();
    }
    this.isKepro = sessionStorage.getItem('isKepro') === 'true';
    const AfbAhsAppnumber = sessionStorage.getItem('AfbAhsAppnumber');
    if (this.isKepro) {
      const payload = {
        applicationNumber: AfbAhsAppnumber, 
        applicationType: "APPLY_BENEFITS",
      };
      this.app.getPendingApplications(null, null,'TCAWB', payload).subscribe((res: any) => {
        if (res?.AFB?.length > 0) {
          const hohDetails = res?.AFB[0]?.headOfHousehold;
          this.headOfHouseholdName = hohDetails?.headOfHousehold;
          this.applicationNum = res?.AFB[0]?.applicationNumber;
          this.hohSSN = hohDetails?.ssn;
          this.hohDob = this.getAge(hohDetails?.dob);
          this.hohGender = hohDetails?.gender;
          this.appStartOn = hohDetails?.startedOn;
          this.appStartedBy = hohDetails?.startedBy;
          this.lastAccessed = hohDetails?.lastAccessedOn;
          this.lastAccessedBy = hohDetails?.lastAccessedBy;
          if (this.applicationNum && this.storageService.getAppNumber() !== this.applicationNum) {
            sessionStorage.setItem('appNum', this.applicationNum);
            this.storageService.setAppNumber(this.applicationNum);
          }
        }
      });
    } else {
      this.app.getHeadOfHouseholdInfo(0, 'NEW', 'NEW').subscribe((res: any) => {
        this.applicationNum = res?.applicationNumber;
        this.headOfHouseholdName = res?.headOfHousehold;
        this.lastAccessed = toISO(res?.lastAccessedOn);
        if (this.applicationNum && this.storageService.getAppNumber() !== this.applicationNum) {
          sessionStorage.setItem('appNum', this.applicationNum);
          this.storageService.setAppNumber(this.applicationNum);
        }
      });
    }
  };

  select (value) {
    this.appType = value;
  }

  next () {
    this.stateService.continueApplication(true);
    sessionStorage.setItem('appType', 'AFB');
    if (this.appType && this.appType === 'continue') this.continueApp();
    else if (this.appType && this.appType === 'new') this.startNewApp();
    else if (this.appType && this.appType === 'ebmsFlow') this.onEBMSClick();
    else {this.setMessage = 'Please select any one of the option to continue'}
  }

  startNewApp () {
    this.stateService.resetStates();
    if (this.applicationNum && this.applicationNum !== '0' && this.applicationNum !== 0) { 
      this.app.deleteApp(this.applicationNum, 'TCWAB').subscribe(() => {
        sessionStorage.setItem('appNum', null);
        this.router.navigateByUrl('/application/' + 'NEW');
      })
    } else {
      this.router.navigateByUrl('/application/' + 'NEW');
    }
    if (sessionStorage.getItem('AfbAHSSearch')) {
      sessionStorage.removeItem('AfbAHSSearch');
    }
  }

    onEBMSClick() {
      sessionStorage.removeItem("ebmsUser")
      sessionStorage.setItem("appType", "AFB");
      const contentHeaders = new HttpHeaders({'pageId': 'TCAFC', 'sessionId' : this.token.getSessionId()});
      const userName = this.mobileUser ? sessionStorage.getItem('userName') : JSON.parse(sessionStorage.currentUser).userId;
      this.apiService.post('indi/ebms/ebms-applications/processEbmsApp', {'userName': userName}, {headers: contentHeaders}).subscribe(res => {
            if (res) {
            this.applicationNum = res?.['appNum'];
            sessionStorage.setItem("appNum", this.applicationNum);
            if (this.applicationNum && this.applicationNum !== '0' && this.applicationNum !== 0) {
              this.beforeStart.startApplication('AFB');
            }
            }
          })
    }

  continueApp() {
    if (this.isKepro) {
      this.modal.confirmHohApp().subscribe(resp => {
        if (resp) {
          const payload = { "appType": "APPLY_BENEFITS" };
          this.app.confirmAppContinue(payload, this.applicationNum,'TCAWB' ).subscribe((res: any) => {
            console.log(res);
            sessionStorage.removeItem('AfbAHSSearch');
            sessionStorage.setItem('isNewApp', 'false');
            if (this.applicationNum && this.applicationNum !== '0' && this.applicationNum !== 0) {
              this.beforeStart.startApplication('AFB');
            } else {
              this.stateService.resetStates();
              this.router.navigateByUrl('/application/' + 'NEW');
            }
          })
        }
      });
    } else {
      sessionStorage.setItem('isNewApp', 'false');
      if (this.applicationNum && this.applicationNum !== '0' && this.applicationNum !== 0) {
        this.beforeStart.startApplication('AFB');
      } else {
        this.stateService.resetStates();
        this.router.navigateByUrl('/application/' + 'NEW');
      }
    }
  }

  onPreviousClick() {
    sessionStorage.removeItem('appType');
    if (this.isKepro) {
      this.router.navigateByUrl('api/prov/coverage-search');
    } else {
      this.router.navigateByUrl('/user-profile');
    }
  }

  getAge = (dob) => {
    var today = new Date();
    var birthDate = new Date(dob);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() <= birthDate.getDate())) {
      age--;
    }
    return age;
  }
} 
